import { Stack, Typography } from "@mui/material";

import { Shared_FormTemplate_QuestionTypeAmountFragment } from "../fragments/fragmentsTypes.generated";
import { NarrowedFormField } from "../types";

type Props = {
    field: NarrowedFormField<Shared_FormTemplate_QuestionTypeAmountFragment>;
    value: string | null | undefined;
};

const formatValue = (val: string) => {
    const [amount, modifier] = val.split(";");
    return modifier ? `${amount} (${modifier})` : amount;
};

export default function QuestionAmountDisplay({ field, value }: Props) {
    return (
        <Stack>
            <Typography variant="caption" color="text.secondary">
                {field.name}
            </Typography>
            <Typography>{value ? formatValue(value) : "—"}</Typography>
        </Stack>
    );
}
